import { useState } from "react";
import styled from "styled-components";

const BorderedCard = ({ title, content }) => {
  const [show, setShow] = useState(true);
  
  if (!show) return null;

  return (
    <CardWrapper>
      <div className="d-flex justify-content-between align-items-start mb-3">
        <h5 className="mb-0 fw-bold" style={{ fontSize: "18px", color: "#383838" }}>
          {title}
        </h5>
        <CloseButton
          onClick={() => setShow(false)}
          aria-label="Close"
          role="button"
        >
          <img src="/Icon/cancel.svg" alt="close" />
        </CloseButton>
      </div>
      <p className="mb-0" style={{ fontSize: "14px", color: "#45464e", lineHeight: "1.6" }}>
        {content}
      </p>
    </CardWrapper>
  );
};

const CardWrapper = styled.article`
  box-shadow: -2px -2px 10px rgba(0, 0, 0, 0.05), 2px 2px 10px rgba(0, 0, 0, 0.05);
  border-left: 8px solid var(--color-secondary);
  border-radius: 10px;
  background-color: #ffffff;
  padding: 24px;
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: -2px -2px 15px rgba(0, 0, 0, 0.08), 2px 2px 15px rgba(0, 0, 0, 0.08);
  }
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: var(--color-primary-soft);
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  img {
    width: 16px;
    height: 16px;
  }
`;

export default BorderedCard;
